import { z } from 'zod';
import { MetaSchema } from './create-chat.js';

/**
 * `GET /api/v1/workstreams/me` contract (ADR-0071 §1, D15-01) — the caller's
 * role in our own table, so the SPA can hide pages it would only render a 403
 * for. **The server enforces; the SPA only hides.** Three tiers, no Viewer.
 * `data` is strict (the BFF authors it); the envelope is loose (ADR-0024 §11).
 */
export const MemberRoleSchema = z.enum(['owner', 'admin', 'member']);
export type MemberRole = z.infer<typeof MemberRoleSchema>;

export const MeDataSchema = z.strictObject({ role: MemberRoleSchema });
export type MeData = z.infer<typeof MeDataSchema>;

export const MeResponseSchema = z.looseObject({ data: MeDataSchema, meta: MetaSchema });
export type MeResponse = z.infer<typeof MeResponseSchema>;
